<template>
    <div class="detail-container">
        <div class="scroll-content">
            <div class="swiper-section">
                <swiper class="swiper-box" indicator-dots="true" indicator-active-color="#D6B788"
                    indicator-color="rgba(255,255,255,0.8)" circular autoplay>
                    <swiper-item v-for="(img, index) in product.showcase_image" :key="index">
                        <img :src="comapi.getImageUrl(img)" mode="aspectFill" class="swiper-img">
                    </swiper-item>
                </swiper>
            </div>
            <div class="info-card">
                <div class="price-row">
                    <div class="left-price-box">
                        <text class="num">¥{{ selectedSku.shop_purchase_price / 100 }}</text>
                    </div>
                </div>
                <text class="product-title">{{ (product.name || '') + '（' + (selectedSku.spec_name || '') + '）'
                    }}</text>
                <div class="meta-row">
                    <span class="sales">销量：{{ selectedSku.sales }}</span>
                    <span class="sales">库存：{{ selectedSku.salable_stock }}</span>
                </div>
            </div>
            <div class="detail-section">
                <div class="section-title">
                    <div class="line"></div>
                    <text class="text">宝贝详情</text>
                    <div class="line"></div>
                </div>
                <div class="detail-images">
                    <!-- 返回的时html格式的字符串 -->
                    <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
                    <div v-html="product.info"></div>
                </div>
            </div>
            <div class="height-90"></div>
        </div>
        <div class="bottom-action-bar">
            <div class="add-cart" @click="openSku">加入购物车</div>
        </div>
        <SkuModal :show="showSkuModal"  :productInfo="currentProduct"  @confirm="handleConfirm" @close="showSkuModal = false" />
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import storeapi from "@/utils/api/store"
import comapi from "@/utils/api/com"
import { showToast } from 'vant';
import SkuModal from '@/components/skumodel.vue'
import { useRoute, useRouter } from "vue-router";
const route = useRoute()
const router = useRouter();
const showSkuModal = ref(false)
const product = ref({})
const selectedSku = ref({})
const currentProduct = ref({})
const productUUID = route.query.product_uuid
// 打开商品详情/添加到购物车
const openSku = () => {
     currentProduct.value = product.value
    showSkuModal.value = true
}
onMounted(() => {
    getProductDetail()
})
const getProductDetail = () => {
    storeapi.getProductDetail({
        uuid: productUUID,
    }).then(res => {
        if (res.code == 200) {
            let data = res.data
            //处理图片showcase_image逗号分隔
            data.showcase_image = data.showcase_image.split(',')
            product.value = data
            // 初始化SKU状态，默认选中第一个规格
            if (data.skus && data.skus.length > 0) {
                selectedSku.value = data.skus[0];
            } else {
                selectedSku.value = {};
            }
        }
    }).catch(() => {
        showToast({ title: '商品详情加载失败', icon: 'none' })
    })
}
const handleConfirm = () => {
    // 确认加入购物车
    showSkuModal.value = false
    showToast('加入购物车成功')
}

</script>

<style lang="less" scoped>
.detail-container {
    display: flex;
    flex-direction: column;
    height: 100vh;
    background-color: #F6F6F6;
    position: relative;

    .scroll-content {
        flex: 1;

        .swiper-section {
            position: relative;
            background-color: #FFF;

            .swiper-box {
                height: 361.5px;

                .swiper-img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .info-card {
            position: relative;
            margin-top: -20px;
            background-color: #FFFFFF;
            border-radius: 23px;
            padding: 15px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);

            .price-row {
                display: flex;
                align-items: baseline;
                justify-content: space-between;
                margin-bottom: 10px;

                .left-price-box {
                    color: #9F3411;
                    font-weight: bold;
                    font-size: 28.5px;
                    line-height: 30.5px;
                    display: flex;
                    align-items: center;
                }
            }

            .product-title {
                font-size: 22.5px;
                font-weight: bold;
                color: #333;
                line-height: 1.4;
                padding-bottom: 19px;
                display: block;
                border-bottom: 1px solid #F3F3F3;
                margin-bottom: 9.5px;
            }

            .meta-row {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .sales {
                    font-size: 13px;
                    color: #999;
                    margin-right: 10px;
                }
            }
        }

        .detail-section {
            margin-top: 10px;
            background-color: #FFFFFF;
            border-radius: 23px;
            padding: 20px 17px 17px 17px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);

            .section-title {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 15px;

                .line {
                    width: 95.5px;
                    height: 1px;
                    background-color: #DDD;
                }

                .text {
                    font-size: 15px;
                    color: #333;
                    margin: 0 10px;
                    font-weight: bold;
                }
            }

            .detail-images {
                font-size: 14px;

                img {
                    width: 100%;
                    display: block;
                }
            }
        }

        .height-90 {
            height: 60px;
        }
    }

    .bottom-action-bar {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        background-color: #FFFFFF;
        display: flex;
        align-items: center;
        padding: 16px 15px 0 15px;
        padding-bottom: calc(5px + env(safe-area-inset-bottom));
        box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.05);
        z-index: 99;

        .add-cart {
            font-size: 15px;
            font-weight: bold;
            background-color: #FFE7CB;
            color: #A15C19;
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-radius: 4px;
            margin-bottom: 10px;
        }
    }
}

/* 加载遮罩样式 */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;

    .loading-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .loading-spinner {
            width: 25px;
            height: 25px;
            border: 4px solid rgba(255, 255, 255, 0.3);
            border-radius: 50%;
            border-top-color: #FFFFFF;
            animation: spin 1s linear infinite;
            margin-bottom: 10px;
        }

        .loading-text {
            font-size: 15px;
            color: #FFFFFF;
        }
    }
}

/* 旋转动画 */
@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}
</style>